import axiosClient from "../axios-client";
import {toastMessage} from "../toaster/toaster";

export const getEmailTemplateList = async () => {
    return axiosClient
        .get("/send/email-templates")
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Templates not found", "error");
            return error;
        });
};

export const getIndividualTemplateData = async (id) => {
    return axiosClient
        .get(`/send/email-template/${id}`)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Templates not found", "error");
            return error;
        });
};


export const sendEmailNotification = async (data) => {
    return axiosClient
        .post(`/send/send-bulk-email`, data)
        .then((res) => {
            toastMessage("Email notification sent successfully!", "success");
        })
        .catch((error) => {
            toastMessage("Email notification not sent", "error");
            return error;
        });
};
